var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('DynamicList',{ref:"dynamicCardList",attrs:{"searchFormStructure":_vm.dataSearchFormStructure,"columns":_vm.dataColumns,"edit":_vm.dataEdit,"onRetrieve":_vm.onRetrieve,"root":"/report/commerce-orders","searchArgs":_vm.searchArgs}},[_vm._t("default",[(_vm.dataCharts !== false)?_c('div',{staticClass:"card-group mb-3 animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.subTotal)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Sous-total")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.total)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Total")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.totalCompleted)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Payé")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.totalBalance)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Balance")))])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"h4 mb-0"},[_vm._v(_vm._s(_vm.Core.Currency.format(_vm.dataCharts.totalRefunded)))]),_c('small',{staticClass:"text-muted text-uppercase font-weight-bold"},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition("Remboursé")))])])])]):_vm._e()],{"slot":"afterList"}),_vm._t("default",[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.$refs.modalExport.open = true}}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition("Exporter sous format ..."))+"\n            ")]),_c('ModalExport',{ref:"modalExport",attrs:{"root":"/report/commerce-orders","formStructure":{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportFormat'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                 {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'id'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'status'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'creationDate'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'orderProductTitles'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'billingFirstname'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'billingLastname'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'billingEmail'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'billingPhone'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'billingCity'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'billingProvince'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'billingCountry'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'billingZipcode'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'total'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'subTotal'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'totalCompleted'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'totalBalance'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'totalRefunded'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'taxes'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'exportFormat',
                                    type: 'select',
                                    options: _vm.Core.Export.formatOptions(),
                                    label: _vm.Core.Definition.getDefinition('Format'),
                                    value: null,
                                    onSelect: function() {}
                                },
                                {
                                    id: 'exportTitle',
                                    type: 'text',
                                    label: _vm.Core.Definition.getDefinition('Titre'),
                                    value: '',
                                    required: true
                                },
                                {
                                    id: 'id',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('ID'),
                                    value: true,
                                    export: 'id',
                                    onChange: function() {}
                                },
                                {
                                    id: 'status',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('État'),
                                    value: true,
                                     export: 'status',
                                    onChange: function() {}
                                },
                                {
                                    id: 'creationDate',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Date de création'),
                                    value: true,
                                     export: 'creationDate',
                                    onChange: function() {}
                                },
                                {
                                    id: 'orderProductTitles',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Produits'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'orderProductTitles',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingFirstname',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Prénom'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'billingFirstname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingLastname',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nom de famille'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'billingLastname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingEmail',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Courriel'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'billingEmail',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingPhone',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Téléphone'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'billingPhone',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingCity',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Ville'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'billingCity',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingCountry',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Pays'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'billingCountry',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingProvince',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Province'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'billingProvince',
                                    onChange: function() {}
                                },
                                {
                                    id: 'billingZipcode',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Code postal'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'billingZipcode',
                                    onChange: function() {}
                                },
                                {
                                    id: 'totalCompleted',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Montant complété'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'totalCompleted',
                                    onChange: function() {}
                                },
                                {
                                    id: 'totalBalance',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Montant balance'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'totalBalance',
                                    onChange: function() {}
                                },
                                {
                                    id: 'totalRefunded',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Montant remboursé'),
                                    value: true,
                                    labelCols: 6,
                                    export: 'totalRefunded',
                                    onChange: function() {}
                                },
                                {
                                    id: 'total',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Total'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'total',
                                    onChange: function() {}
                                },
                                 {
                                    id: 'subTotal',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Sous-total'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'subTotal',
                                    onChange: function() {}
                                },
                                 {
                                    id: 'taxes',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Taxes'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'taxes',
                                    onChange: function() {}
                                }
                            ]}},on:{"onSubmit":_vm.onExport}})],{"slot":"afterSearchForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }